import { useHomeTeam } from "../hooks/useHomeTeam";
import { BoldHeading } from "./CoolHeading";

export function CheeseburgerTime() {
  const { slogans } = useHomeTeam();

  return (
    <>
      <BoldHeading>{slogans.inmatch}</BoldHeading>
      <iframe
        data-testid="embed-iframe"
        style={{ borderRadius: "1rem" }}
        src="https://open.spotify.com/embed/track/2hTx8adLNJBwhLsavI1Xvr?theme=0"
        width="100%"
        height="352"
        allowFullScreen
        allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
        loading="lazy"
      ></iframe>
    </>
  );
}
